import React from 'react'
import "./index.css"
function PrivacySection() {
  return (
    <section class="event1 event2 csrSec">
      <div class="container">
        <div class="eventHead aosAnim ltr">
          <h3 class="titleText">Data Privacy and Personal Information Policy</h3>
          <h5>Biz Hero India Pvt. Ltd. (operating under the brand name 'NowPurchase')</h5>
        </div>
        <div class="csrContent aosAnim">
          <div class="csrP">
            <p>
              NowPurchase establishes data privacy initiatives to safeguard personal information. To be compliant with Indian Data Privacy requirements, NowPurchase has adopted this Data Privacy and Personal Information Policy to raise privacy awareness and overall accountability within the Company. The Policy outlines NowPurchase's privacy principles and establishes responsibilities for employees when handling personal information.
            </p>
            <p></p>
            <p>
              <strong>In this document:</strong>
            </p>
            <p>
              The terms 'we', 'us' and 'our' refer to Biz Hero India Pvt. Ltd. operating under the brand name 'NowPurchase'.
            </p>
            <p>
              The terms 'you' and 'your' refer to our employees, contractors, interns, and personnel.
            </p>
            <p>
              The terms 'employee' and 'employment' relate to fulltime, part-time, contract workers, interns, and volunteers.
            </p>
            <p>
              <strong>Scope</strong>
            </p>
            <p>
              "Personal Information" means information that, when associated with an individual, can be used to identify him or her, regardless of the medium in which the information is collected, processed, or transferred.
            </p>
            <p>
              This applies to all employees in Biz Hero India Pvt Ltd operating under the brand name 'NowPurchase'.
            </p>
            <p>
              <strong>Name and Address of the Entity</strong>
            </p>
            <p>
              The entity collecting, processing, and retaining personal information is:
            </p>
            <p>
              Biz Hero India Pvt. Ltd. (operating under the brand name 'NowPurchase')
            </p>
            <p>
              Registered Office: 28/1 Shakespeare Sarani, 31 Ganga Jamuna Building, Kolkata 700017
            </p>
            <p>
              Corporate Office: 2nd Floor, Kariwala Towers, J1-5, EP Block, Sector V, Salt Lake, Kolkata 700091
            </p>
            <p>
              <strong>What Personal Information We Collect</strong>
            </p>
            <p>
              "Personal Information" includes your name, address, date of birth, contact details, educational background, employment history, references, results of employment checks, passport details, Aadhaar and PAN number.
            </p>
            <p>
              We may collect information relating to your family members for benefits, insurance, statutory compliance, or emergency purposes.
            </p>
            <p>
              Your provision of personal information may be mandatory for statutory and employment purposes. Optional information will be clearly indicated as such. Failure to provide mandatory information may affect our ability to administer employment benefits or maintain an employment relationship with you.
            </p>
            <p>
              If you provide personal information of anyone other than yourself, you confirm that you have informed the individual and obtained their consent for sharing their information with us.
            </p>
            <p>
              By providing us with personal information, you agree to the terms of this Policy and consent to the collection, use, and disclosure of such information in accordance with applicable laws, including the Information Technology Act, 2000 and the SPDI (Sensitive Personal Data or Information) Rules, 2011.
            </p>
            <p>
              You must ensure that all personal information provided is accurate, complete, and updated in a timely manner.
            </p>
            <p>
              <strong>Our Purposes for Collection, Use and Disclosure</strong>
            </p>
            <p>
              We collect personal information from you for the purpose of managing your employment relationship with us, including: background verification, payroll processing and statutory compliance (PF, ESIC, taxes), insurance and employee benefits administration, monitoring and evaluating performance and conduct, employment progression and opportunities within NowPurchase, responding to health, safety, or emergency situations, and managing your overall employment lifecycle.
            </p>
            <p>
              We may also collect and use personal information to comply with internal policies, legal requirements, security procedures, research, planning, and organizational development.
            </p>
            <p>
              We may disclose personal information to the following, strictly on a need-to-know basis: statutory bodies (EPFO, ESIC, government authorities), background verification agencies, payroll processors and auditors, insurance and benefits providers, technology vendors handling secure systems, and customers, where required for work-related purposes.
            </p>
            <p>
              We may disclose personal information to prospective employers for reference checks if legally permitted.
            </p>
            <p>
              We may also collect, use, and disclose personal information where required or permitted by law.
            </p>
            <p>
              SPDI (Sensitive Personal Data or Information) may be transferred outside India only when necessary for fulfilling a lawful contract or with the employee's consent, and only when the receiving entity ensures the same level of data protection as mandated under the SPDI Rules.
            </p>
            <p>
              <strong>Protection and Retention of Personal Information</strong>
            </p>
            <p>
              NowPurchase follows reasonable security practices and procedures, appropriate to the nature of its business and size of operations, to protect personal information from unauthorized access, misuse, alteration, or disclosure, in accordance with Rule 8 of the SPDI Rules, 2011.
            </p>
            <p>
              We retain personal information only as long as required for business or legal purposes and securely delete, archive, or anonymize it thereafter.
            </p>
            <p>
              <strong>Access to and Correction of Personal Information</strong>
            </p>
            <p>
              You may request access or correction to your personal information by contacting the Grievance Officer.
            </p>
            <p>
              Requests may be declined if restricted by applicable laws or if data has been disposed of per retention policy.
            </p>
            <p>
              You may withdraw your consent for processing of personal information by notifying the Grievance Officer. However, withdrawal of consent for mandatory employment or statutory information may affect your ability to continue employment or receive certain benefits.
            </p>
            <p>
              <strong>Feedback</strong>
            </p>
            <p>
              If you have a concern regarding your personal information, you may contact the Grievance Officer.
            </p>
            <p>
              <strong>Related Policy</strong>
            </p>
            <p>
              Information Technology (Reasonable Security Practices and Procedures and SPDI Rules, 2011)
            </p>
            <p>
              <strong>Grievance Officer</strong>
            </p>
            <p>
              Ms. Neha Paria
            </p>
            <p>
              General Manager – HR
            </p>
            <p>
              Email: neha@nowpurchase.com
            </p>
            <p>
              Phone: 6292137488
            </p>
            <p>
              All grievances will be resolved within one month in accordance with Rule 5(9) of the SPDI Rules.
            </p>
            <p>
              <strong>Governing Law and Jurisdiction</strong>
            </p>
            <p>
              This Policy shall be governed by and construed in accordance with the laws of India. The courts at Kolkata, West Bengal, shall have exclusive jurisdiction over any disputes arising out of or in connection with this Policy.
            </p>
            <p>
              <strong>CERT-In Compliance</strong>
            </p>
            <p>
              The Company complies with the directions issued by the Indian Computer Emergency Response Team (CERT-In), including the directions dated April 28, 2022, as applicable to the Company's operations. This includes compliance with requirements relating to cybersecurity practices, maintenance of logs, data retention, and timely reporting of cybersecurity incidents.
            </p>
            <p>
              <strong>Aadhaar Compliance</strong>
            </p>
            <p>
              Where the Company processes Aadhaar numbers or Aadhaar-related information, such processing shall be undertaken strictly in accordance with the Aadhaar (Targeted Delivery of Financial and Other Subsidies, Benefits and Services) Act, 2016 and the Aadhaar (Sharing of Information) Regulations, 2016. Aadhaar information shall be collected, used, stored, or shared only where legally permitted.
            </p>
            <p>
              <strong>Third Party Data Sharing</strong>
            </p>
            <p>
              Personal Information and SPDI shall be shared only with third parties that maintain the same level of data protection as adhered to by the Company. All such sharing shall be governed by written agreements containing confidentiality and data protection obligations. The Company maintains executed contracts and underlying documentation evidencing such safeguards.
            </p>
            <p></p>
            <p>Contact Us</p>
            <p>
              If you have any questions or concerns regarding this Privacy Policy, please contact us at
              <a href="mailto:neha@nowpurchase.com">
                neha@nowpurchase.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
export default PrivacySection